import SelectDropdown from 'components/ui/Forms/SelectDropdown';
import { useAddUsersToProject } from 'context/AddUsersToProjectContext';
import { useState, useEffect, useRef } from 'react';
import SelectUserItem from './SelectUserItem';

const SelectDropdownUsers = () => {
  const [showOptions, setShowOptions] = useState(false);
  const { addUser, users, inputValue, handleInputValue } = useAddUsersToProject();
  const dropdownRef = useRef(null); 

  // Manejar clics fuera del dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []); 

  const handleAddUser = (user) => {
    addUser(user);
    setShowOptions(false);
  };
    
  return (
    <div ref={dropdownRef}>
      <SelectDropdown
        showOptions={showOptions}
        setShowOptions={setShowOptions}
        label="Usuarios"
        name="Usuarios"
        containerClassName="select-dropdown-add-user"
        selectValue={inputValue}
        onChangeValue={handleInputValue}
        placeholder="Escribe al menos 3 letras para empezar a filtrar"
      >
        {users.map((user) => (
          <SelectUserItem key={user.user_id} user={user} addUser={handleAddUser} />
        ))}
        {users.length === 0 && (
          <p className="text-not-data-found">No hay usuarios disponibles</p>
        )}
      </SelectDropdown>
    </div>
  );
};

export default SelectDropdownUsers;
